import { ASSESSMENT_TIMING_DEFAULTS } from '../../../z50-domaincomp/constants/assessment-timing-defaults';
import type { Assessment } from './types';

// Default time per question in seconds (centralized constant)
const DEFAULT_SECONDS_PER_QUESTION = ASSESSMENT_TIMING_DEFAULTS.DEFAULT_SECONDS_PER_QUESTION;

/**
 * Calculates the default time for a question (30 seconds)
 */
export function getDefaultQuestionTime(): number {
  return DEFAULT_SECONDS_PER_QUESTION;
}

/**
 * Calculates the default time for a section based on number of questions
 * @param questionCount - Number of questions in the section
 * @returns Default time in seconds (questionCount * 30)
 */
export function getDefaultSectionTime(questionCount: number): number {
  return questionCount * DEFAULT_SECONDS_PER_QUESTION;
}

/**
 * Gets the effective time limit for a question, using default if value is 0 or null
 */
export function getEffectiveQuestionTime(value: number | null | undefined): number {
  if (value === null || value === undefined || value === 0) {
    return getDefaultQuestionTime();
  }
  return value;
}

/**
 * Gets the effective time limit for a section, using default if value is 0 or null
 */
export function getEffectiveSectionTime(value: number | null | undefined, questionCount: number): number {
  if (value === null || value === undefined || value === 0) {
    return getDefaultSectionTime(questionCount);
  }
  return value;
}

/**
 * Calculates total points for an assessment
 */
export function calcPoints(assessment: Assessment) {
  assessment.Points = 0;
  assessment.Sections.forEach(s => {
    s.Points2 = 0;
    s.Questions.forEach(q => {
      s.Points2 += q.Points3;
    });
    assessment.Points += s.Points2;
  });
}

/**
 * Helper function for reordering arrays
 */
export function reorder<T>(list: T[], startIndex: number, endIndex: number): T[] {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);
  return result;
}

